import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, IconButton, Typography } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useNavigate } from "react-router-dom";

export default function DemoLayout({ title, children }) {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width: 700px)");

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#0e052e" }}>
      <Box
        sx={{
          background: "rgba(14,5,46,0.85)",
          backdropFilter: "blur(24px)",
          WebkitBackdropFilter: "blur(24px)",
          borderBottom: "1px solid rgba(255,131,168,0.85)",
          boxShadow: "0 4px 30px rgba(0,0.85)",
          px: isMobile ? 2 : 5,
          py: 2,
          position: "sticky",
          top: 0,
          zIndex: 1000,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IconButton
            onClick={() => navigate("/")}
            sx={{
              color: "rgba(255,255,255,0.85)",
              p: 0.75,
              "&:hover": {
                borderColor: "#FF83A8",
                background: "rgba(255,131,168,0.10)",
              },
            }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography
            variant={isMobile ? "h5" : "h4"}
            color="secondary"
            sx={{
              fontFamily: "Nickainley",
              cursor: "pointer",
              lineHeight: 1,
            }}
            onClick={() => navigate("/")}
          >
            Patricia Milou
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "rgba(255,255,255,0.85)",
              fontFamily: "RobotoLight",
              fontWeight: 300,
              fontSize: "0.88rem",
            }}
          >
            / {title}
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          p: isMobile ? 2 : 4,
          backgroundImage:
            "radial-gradient(ellipse at 15% 15%, rgba(255,131,168,0.85)",
          backgroundAttachment: "fixed",
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
